import { render, staticRenderFns } from "./HorseItemSearch.vue?vue&type=template&id=5b60661c&"
import script from "./HorseItemSearch.vue?vue&type=script&lang=js&"
export * from "./HorseItemSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports